<template>
  <IncrementalDataProvider>
    <template #default="{ props, listeners }">
      <div
        v-if="props.ui.showComponentOnLoad"
        :class="{'animating': props.ui.animating }"
        class="IncrementalData card"
        data-rmpdev-selector="update-user-form"
      >
        <div class="card-content">
          <div
            v-if="props.hasQuestionsToAnswer"
            class="IncrementalData-stepper"
          >
            <progress-stepper
              :steps="props.steps"
            />
          </div>

          <keep-alive>
            <transition
              name="animateLeft"
              @before-enter="listeners.setAnimationStatus(true)"
              @after-leave="listeners.setAnimationStatus(false)"
            >
              <component
                :is="props.currentQuestion.component"
                ref="IncrementalDataQuestion"
                :loading="props.ui.loading"
                :server-validation-errors="props.form.serverValidationErrors"
                :user="props.user"
                :validate-all="props.form.validateAll"
                @incremental-data-field:submit="listeners.updateUser"
                @incremental-data-field:validation-error="listeners.showValidationErrors"
              />
            </transition>
          </keep-alive>
        </div>
        <div
          v-if="props.hasQuestionsToAnswer"
          class="card-footer"
        >
          <div class="card-footer-item has-text-left has-no-border">
            {{ props.currentQuestion.index }} of {{ props.steps.length }}
          </div>
          <div class="card-footer-item has-no-border">
            <button
              :class="{'is-loading': props.ui.loading }"
              class="Button Button--primary Button--long"
              @click="handleQuestionSubmission"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </template>
  </IncrementalDataProvider>
</template>

<script>
import ProgressStepper from '@/components/common/progress-stepper.vue';
import IncrementalDataProvider from './incremental-data-provider.vue';

export default {
  components: { ProgressStepper, IncrementalDataProvider },
  data() {
    return {};
  },

  methods: {
    handleQuestionSubmission() {
      this.$refs.IncrementalDataQuestion.submit();
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "../../../scss/abstracts/abstracts";
  .IncrementalData-stepper {
    margin-bottom: spacing();
  }
</style>
